import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { Linking, StyleProp, StyleSheet, Text, TextStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  style?: StyleProp<TextStyle>;
  url: string;
}

export const OldWebLink: React.FC<Props> = ({ url, style }) => (
  <Text
    onPress={() => {
      Analytics.track('old_url_link.press', {
        location: 'login_screen',
      });
      Linking.openURL(url);
    }}
    style={[TYPOGRAPHY.small, styles.text, style]}
  >
    {i18n.t('switch_to_old_version')}
  </Text>
);

const styles = StyleSheet.create({
  text: {
    textDecorationLine: 'underline',
  },
});
